angular.module('impactx.catalog').controller('CatalogPriceExportCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'DownloadService',
    'TranslationService',
    CatalogPriceExportCtrl
]);

function CatalogPriceExportCtrl($scope, dataGen, ToastService, $mdDialog, DownloadService, TranslationService) {
    var ctrl = this;

    ctrl.getData = function () {
        var paramObj = {
            id: ctrl.catId
        };
        dataGen.getData($scope, paramObj, '/catalog/prices/viewexport').then(function () {
            if ($scope && $scope.trns) {
                $scope.trns.cancel = TranslationService.get('abort');
            }
        });
    };

    ctrl.export = function () {
        var paramObj = {
            data: $scope.data
        };
        dataGen.postAsForm($scope, paramObj, '/catalog/prices/export').then(function () {
            $mdDialog.hide();
            ToastService.openStandardToast($scope.trns.startedDownload);
        });
    };

    ctrl.download = function (id) {
        DownloadService.openDownloadPost('/catalog/prices/downloadexport', {paramName: "id", paramValue: parseInt(id)})
    }

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.getData();
}